import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { AuthenticationPipe } from './authentication/authentication.pipe';
import { AuthenticationService } from './authentication/authentication.service';
import { ImpureAuthenticationPipe } from './authentication/impure-authentication.pipe';
import { ConfigurationService } from './config/config.service';
import { SiteService } from './config/site.service';
import { CustomComponentDirective } from './helper/custom-component.directive';
import { NumberDirective } from './helper/number.directive';
import { LookupAsyncPipe } from './lookup/lookup-async.pipe';
import { LookupPipe } from './lookup/lookup.pipe';
import { Configuration } from './models/configuration';
import { AssetsI18nLoader } from './translate/assets-i18n-loader';
import { ScrollIntoViewDirective } from './helper/scroll-into-view.directive';

export function initSiteConfig(siteService: SiteService): () => Promise<void> {
    return (): Promise<void> => {
        return new Promise((resolve: any): void => {
            void siteService.load().then(() => {
                resolve();
            });
        });
    };
}

export function initConfig(siteService: SiteService, appConfig: ConfigurationService): () => Promise<void> {
    return async (): Promise<void> => {
        await siteService.subConfig().pipe(filter((val: boolean) => val), take(1)).toPromise();
        void appConfig.loadConfig();
    };
}

// für die app gibt es den standard pfad und keinen lib namen!
export function initI18n(i18n: AssetsI18nLoader): () => Promise<any> {
    return (): Promise<any> => i18n.init(null, null, 1);
}

// die core lib mit stadnard pfad und lib namen
export function initI18nCore(i18n: AssetsI18nLoader): () => Promise<any> {
    return (): Promise<any> => i18n.init(null, 'core');
}

export function initAuthService(authService: AuthenticationService): () => Promise<void> {
    return (): Promise<void> => authService.init();
}

// @dynamic
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        LookupPipe,
        LookupAsyncPipe,
        AuthenticationPipe,
        ImpureAuthenticationPipe,
        NumberDirective,
        CustomComponentDirective,
        ScrollIntoViewDirective,
    ],
    exports: [
        LookupPipe,
        LookupAsyncPipe,
        AuthenticationPipe,
        ImpureAuthenticationPipe,
        NumberDirective,
        CustomComponentDirective,
        ScrollIntoViewDirective,
    ],
})
export class CoreModule {
    public static forRoot(configuration?: () => Configuration): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: APP_INITIALIZER, useFactory: initSiteConfig, deps: [ SiteService ], multi: true },
                { provide: APP_INITIALIZER, useFactory: initConfig, deps: [ SiteService, ConfigurationService ], multi: true },
                { provide: APP_INITIALIZER, useFactory: initI18n, deps: [ AssetsI18nLoader ], multi: true },
                { provide: APP_INITIALIZER, useFactory: initI18nCore, deps: [ AssetsI18nLoader ], multi: true },
                { provide: APP_INITIALIZER, useFactory: initAuthService, deps: [ AuthenticationService ], multi: true },
                { provide: Configuration, useFactory: configuration },
            ],
        };
    }
}
